import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import 'jquery-slimscroll';
import { AppInformationService, AuthService } from '../../core/core.module';

declare var jQuery: any;

@Component({
    standalone: false,
    selector: 'app-navigation',
    templateUrl: 'navigation.template.html',
})
export class NavigationComponent implements AfterViewInit {
    constructor(
        private router: Router,
        public auth: AuthService,
        public appInfo: AppInformationService
    ) {}

    async ngAfterViewInit() {
        setTimeout(() => {
            jQuery('#side-menu').metisMenu();
        });

        const currentUser = await this.auth.currentUser;
        if (!!currentUser && (currentUser.userName === 'timeCard')) {
            jQuery('body').addClass('mini-navbar');
        } else {
            jQuery('body').removeClass('mini-navbar');
        }

        jQuery('.sidebar-collapse').slimscroll({
            height: '100%',
        });
    }

    activeRoute(routename: string): boolean {
        return this.router.url.indexOf(routename) > -1;
    }

    hasRole(role: string) {
        return this.auth.hasRole(role);
    }

    showAdmin() {
        return this.auth.hasRole('Admin');
    }
    showCustomer() {
        return this.auth.hasRole('Customers') || this.auth.hasRole('Customers:Admin') || this.auth.hasRole('Admin');
    }
    showQuote() {
        return this.auth.hasRole('Customers:Admin') || this.auth.hasRole('Admin');
    }
    showInvoices() {
        return this.auth.hasRole('Invoices') || this.auth.hasRole('Invoices:Admin') || this.auth.hasRole('Admin');
    }
    showProducts() {
        return this.auth.hasRole('Products') || this.auth.hasRole('Products:Admin') || this.auth.hasRole('Admin');
    }
    showVendors() {
        return this.auth.hasRole('Vendors') || this.auth.hasRole('Vendors:Admin') || this.auth.hasRole('Admin');
    }
    showReports() {
        return this.auth.hasRole('Reports') || this.auth.hasRole('Reports:Admin') || this.auth.hasRole('Admin');
    }
    showQuickBooks() {
        return this.auth.hasRole('QuickBooks') || this.auth.hasRole('QuickBooks:Admin') || this.auth.hasRole('Admin');
    }


}
